import * as yup from 'yup';
import { nullTypeError } from 'utils/yup';
import { __ } from 'utils/form';
import { Formik, Field, Form, type FormikHelpers } from 'formik';
import TextArea from 'components/inputs/TextArea';
import Button from 'components/common/Button';
import ErrorMessage from 'components/common/ErrorMessage';
import { ArrowForward } from 'assets/icons';
import { useIntl } from 'react-intl';
import styles from './ContactForm.module.scss';

export interface IContactFormValues {
  message: string;
  /** Not a field: the form-level error (`setErrors({ form })`) is read from `errors.form`. */
  form?: string;
}

interface IContactFormProps {
  onSubmit: (
    values: IContactFormValues,
    formikHelpers: FormikHelpers<IContactFormValues>,
  ) => void | Promise<unknown>;
}

const initialValue: IContactFormValues = {
  message: '',
};

const contactShape = {
  message: yup
    .string()
    .required(__('errors.message_required'))
    .nonNullable(nullTypeError('string')),
};

const contactParamsSchema = yup.object().shape(contactShape);

const ContactForm = ({ onSubmit }: IContactFormProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <Formik initialValues={initialValue} validationSchema={contactParamsSchema} onSubmit={onSubmit}>
      {({ isSubmitting, errors }) => (
        <div className={styles.container}>
          <Form>
            <Field
              name="message"
              component={TextArea}
              minRows={15}
              label={t({ id: 'contact.note' })}
            />
            {errors.form && <ErrorMessage message={errors.form} />}
            <div className={styles.buttonContainer}>
              <Button
                disabled={isSubmitting}
                loading={isSubmitting}
                type="submit"
                endIcon={<ArrowForward />}
              >
                {t({ id: 'contact.note' })}
              </Button>
            </div>
          </Form>
        </div>
      )}
    </Formik>
  );
};

export default ContactForm;
